import type {
    GetLeadHistoryParams,
    LeadHistoryList,
    LeadHistoryRetrySource,
    LeadHistoryRow,
} from "../../../helpers/leads/reports";

export interface GetLeadHistoryAsyncPayload extends GetLeadHistoryParams {
    connectionId: string;
}

export interface RetryLeadHistoryPayload {
    connectionId: string;
    stat_ids: number[];
    source: LeadHistoryRetrySource;
    /** Present for a history retry so the list reloads with the same query. */
    listParams?: GetLeadHistoryParams;
}

export interface LeadHistoryState {
    leads: LeadHistoryRow[];
    pagination: LeadHistoryList["pagination"];
    isLeadHistoryLoading: boolean;
    leadHistoryError: string | null;
    isRetryLoading: boolean;
    retryError: string | null;
    retryingStatId: number | null;
}

export const initialState: LeadHistoryState = {
    leads: [],
    pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1,
    },
    isLeadHistoryLoading: false,
    leadHistoryError: null,
    isRetryLoading: false,
    retryError: null,
    retryingStatId: null,
};
